import React from "react";
import { StudentStatusIcon } from "../../School/components/StudentProfiles";

const ImmunizationBadge = ({
  handleVaccineGroupToggle,
  immunizationRecord,
}) => {
  return (
    <div
      className="d-flex align-items-center immunization-badge"
      onClick={() => handleVaccineGroupToggle(immunizationRecord.name)}
    >
      <StudentStatusIcon
        className="me-2 mb-auto"
        status={immunizationRecord.immunization_record_status}
      />
      <div>
        <div className="body-medium-normal">
          {immunizationRecord.name}
        </div>
        <div className="body-small-regular text-muted">
          {immunizationRecord.num_doses} doses
        </div>
      </div>
    </div>
  );
};

const ImmunizationBadgesRow = ({
  handleVaccineGroupToggle,
  immunizationRecords,
}) => {
  return (
    <div className="immunization-badges-row">
      {Object.keys(immunizationRecords).map((record) => (
        <div key={record}>
          <ImmunizationBadge
            immunizationRecord={immunizationRecords[record]}
            handleVaccineGroupToggle={handleVaccineGroupToggle}
          />
        </div>
      ))}
    </div>
  );
};

export default ImmunizationBadgesRow;